import {IndustryService} from '../service/industry.service';
import {Injectable} from '@angular/core';

@Injectable()
export class IndustryInteractor {
    constructor(private readonly industryService: IndustryService) {
    }

    async getAll(): Promise<String[]> {
        return await this.industryService.getAll();
    }
}